import styled from 'styled-components';

export const ObjectWrapper = styled.span`
  cursor: pointer;
  font-weight: 500;
  color: #637bd0;
`;

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  color: #6989ab;
  cursor: pointer;
  margin-left: auto;
`;
